export const speechConfig = {
  semantics: true,
  domain: "mathspeak",
  style: "default",
  speakText: true,
  speech: "deep",
  modality: "speech",
};

export const speakerClass = {
  question: {
    learnosity: "lrn_question",
    app: "div_speaker_question",
  },
  feature: {
    learnosity: "lrn_sharedpassage",
    app: "div_speaker_feature",
  },
  option: {
    learnosity: "lrn-mcq-option",
    app: "div_speaker_options",
  },
  dragDropOption: {
    learnosity: "lrn_btn_drag",
    app: "div_speaker_dragdrop_options",
  },
  dragDropPrompt: {
    learnosity: "lrn_response_input",
    app: "div_speaker_dragdrop_prompt",
  },
};
